import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// ---- iOS dynamic viewport fix (Safari/Chrome on iPhone) ----
function setAppViewportUnits() {
  // visualViewport is best on iOS (accounts for toolbars)
  const vv = window.visualViewport;
  const height = vv?.height || window.innerHeight;

  // 1vh in px
  const vh = height * 0.01;

  document.documentElement.style.setProperty("--app-vh", `${vh}px`);
  document.documentElement.style.setProperty("--app-height", `${height}px`);
}

// Run once ASAP
setAppViewportUnits();

// Update on resize/orientation + toolbar show/hide changes
window.addEventListener("resize", setAppViewportUnits);
window.addEventListener("orientationchange", setAppViewportUnits);

// visualViewport fires when iOS toolbars expand/collapse (scrolling)
if (window.visualViewport) {
  window.visualViewport.addEventListener("resize", setAppViewportUnits);
  window.visualViewport.addEventListener("scroll", setAppViewportUnits);
}


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
